@if(!isMobileApp)
{
<ion-card class="card-common-blue ion-no-margin ion-margin-top ion-margin-bottom">

  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <span class="cst-icon icon-credit-card"></span>
        <span>
          {{ 'PRE_USE_LABEL10' | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <ion-card-content [class]="isMobileApp ? 'ion-no-padding' : ''">

    <ion-grid class="ion-margin-top commonGrid">
      <!-- Grid header -->
      <ion-row class="gridHead">
        <ion-col size="2.5" class="bold lh-normal" translate>PRE_USE_LABEL5</ion-col>
        <ion-col size="2" class="bold lh-normal" translate>PRE_USE_LABEL13</ion-col>
        <ion-col size="3.5" class="bold lh-normal" translate>PRE_USE_LABEL7</ion-col>
        <ion-col size="2" class="bold lh-normal" translate>PRE_USE_LABEL8</ion-col>
        @if(isActiveVehicleSelected)
        {
        <ion-col size="2" class="bold lh-normal" translate>PRE_USE_LABEL9</ion-col>
        }
      </ion-row>

      <!-- Grid data rows -->
      @for (details of itemsList(); track $index) {

      <ion-row class="gridData">
        <ion-col size="2.5">
          {{ details.inspectioN_REPORT_DATE| formatDate: isMobileApp }}
        </ion-col>

        <ion-col size="2">
          {{details.shorT_INSPECTION_ID}}
        </ion-col>

        <ion-col size="3.5">
          {{details.vehiclE_INSPECTION_DESCRIPTION}}
        </ion-col>

        <ion-col size="2" [ngClass]="{'text-danger-accent': details.defecT_COUNT>0}">
          {{details.defecT_COUNT}}
        </ion-col>

        @if(isActiveVehicleSelected)
        {
        <ion-col size="2">
          <ion-icon (click)="navigatePUI(details.veH_INSPECT_RPT_ID)"
            (keydown.enter)="navigatePUI(details.veH_INSPECT_RPT_ID)" src="assets/imgs/magnifying-glass.svg"
            class="btnIcon cursor-pointer">
          </ion-icon>
        </ion-col>
        }

      </ion-row>

      }
    </ion-grid>
    @if (!itemsList() || itemsList().length === 0) {
    <ion-row class="ion-margin-top">
      <ion-col size="12" class="ion-text-center d-flex justify-content-center">
        {{ 'PRE_USE_INSPECTION_NOT_FOUND' | translate }}
      </ion-col>
    </ion-row>
    }

  </ion-card-content>
</ion-card>
}

@if(isMobileApp)
{

<ion-text class="primary-color font-family-bold pui_mobile_title font-xl ">
  {{'PRE_USE_LABEL10' | translate}}
</ion-text>

@for (details of itemsList(); track $index) {
<ion-card (click)="navigatePUI(details.veH_INSPECT_RPT_ID)" (keydown.enter)="navigatePUI(details.veH_INSPECT_RPT_ID)"
  class="card-common ion-no-margin ion-margin-vertical ion-no-padding ion-padding-start cursor-pointer">
  <div class="align-items-center d-flex ion-margin-top justify-content-between">
    <ion-text class="primary-color font-family-bold font-md">
      {{ details.inspectioN_REPORT_DATE | formatDate: isMobileApp }}
    </ion-text>

    <ion-label class="iconWrapper ion-margin-end">
      <ion-icon src="assets/imgs/holman/card-menu.svg" class="cardMenuIcon"></ion-icon>
    </ion-label>

  </div>

  <ion-row class="primary-color">
    <ion-col size="4">
      {{ 'PRE_USE_LABEL13' | translate }}:
    </ion-col>
    <ion-col size="8">
      {{details.shorT_INSPECTION_ID}}
    </ion-col>
  </ion-row>

  <ion-row class="primary-color">
    <ion-col size="4">
      {{ 'PRE_USE_LABEL18' | translate }}:
    </ion-col>
    <ion-col size="8">
      {{details.vehiclE_INSPECTION_DESCRIPTION}}
    </ion-col>
  </ion-row>

  <ion-row class="primary-color ion-margin-bottom">
    <ion-col size="4">
      {{ 'PRE_USE_LABEL19' | translate }}:
    </ion-col>
    <ion-col [ngClass]="{'text-danger-accent': details.defecT_COUNT>0}" size="8">
      {{details.defecT_COUNT}}
    </ion-col>
  </ion-row>
</ion-card>
}

@if (!itemsList() || itemsList().length === 0) {
<ion-row class="ion-margin-top ion-margin-bottom">
  <ion-col size="12" class="ion-text-center d-flex justify-content-center">
    {{ 'PRE_USE_INSPECTION_NOT_FOUND' | translate }}
  </ion-col>
</ion-row>
}
}